export default "__VITE_ASSET__BI_G9H0Z__"